import type { LoaderFunction } from 'react-router';

import type { RouteProps } from '../../../shared/RouteProps';
import { extractCompanyIdFromSlug } from '../../../shared/utils/extractCompanyIdFromSlug';
import { mapSalariesModel } from './mappers';

export const OPEN_JOBS_LISTING_SIZE_FOR_SALARIES = 4; // Default page size for salaries

export const salariesLoader =
  ({ services }: RouteProps): LoaderFunction =>
  async ({ params, request }) => {
    const companyId = extractCompanyIdFromSlug(params.companySlug);
    if (companyId === undefined) {
      throw new Error(
        `Could not find companyId from params: ${JSON.stringify(params)}`,
      );
    }

    const url = new URL(request.url);
    const isDraft = url.searchParams.get('draft') === 'true';

    const companyDetails =
      await services.companyDetailsService.getCompanyDetails(
        companyId,
        Boolean(isDraft),
      );

    const jobs = await services.companyProfileService.getJobs(
      companyDetails?.companyProfile?.organisationId ?? undefined,
      1,
      OPEN_JOBS_LISTING_SIZE_FOR_SALARIES,
    );

    return mapSalariesModel(companyId, companyDetails, jobs);
  };
